import React, { forwardRef, memo } from 'react'

const PlusCircleIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="29.4"
      height="29.4"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M20.7243 36.5307C29.1777 36.5307 36.0305 29.6779 36.0305 21.2246C36.0305 12.7712 29.1777 5.91846 20.7243 5.91846C12.271 5.91846 5.41821 12.7712 5.41821 21.2246C5.41821 29.6779 12.271 36.5307 20.7243 36.5307Z"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeMiterlimit="10"
      />
      <path
        d="M14.3472 21.2246H27.1023"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7246 14.8469V27.602"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

PlusCircleIcon.displayName = 'PlusCircleIcon'

export default memo(PlusCircleIcon)
